import { useTokenManagement } from "./lib";
import { AppRouter } from "./router";
import { useEffect } from "react";
import { selectMe, useGetMyProfileQuery } from "../entities/me";
import { useAppSelector } from "./store";
import { LoadingIndicator } from "../shared/ui/loading-indicator";
import { REFRESH_TOKEN_INTERVAL } from "../shared/constants/auth";

export const App = () => {
  const { refreshStoredToken, isTokenManagementLoaded } = useTokenManagement();
  const { isLoading: isMeLoading, isUninitialized } = useGetMyProfileQuery(
    undefined,
    {
      skip: !isTokenManagementLoaded,
    },
  );
  const me = useAppSelector(selectMe);

  useEffect(() => {
    refreshStoredToken();

    const intervalId = setInterval(refreshStoredToken, REFRESH_TOKEN_INTERVAL);

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        refreshStoredToken();
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [refreshStoredToken]);

  if (isMeLoading || isUninitialized) {
    return <LoadingIndicator />;
  }

  return <AppRouter user={me} />;
};
